import { CheckCircleIcon } from "lucide-react";

import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateHeading,
  EmptyStateIcon,
} from "@/components/ui/empty-state";
import { NavList, NavListItem } from "@/components/ui/nav-list";
import type { TAccession } from "@/lib/types";
import { useNavSelected } from "@/utils/useNavStack";
import { ReportListItem, ReportLoadingItem } from "./ReportListItem";

export function ReportsList({
  accessions,
  isLoading,
  queuedIds = [],
  onGenerated,
}: {
  accessions: TAccession[];
  isLoading?: boolean;
  queuedIds?: readonly number[];
  onGenerated?: (ids: number[]) => void;
}) {
  const { selected } = useNavSelected();

  return (
    <NavList
      autoFocus
      items={accessions}
      isLoading={isLoading}
      loadingItems={30}
      LoadingComponent={ReportLoadingItem}
      initialIndex={accessions.findIndex((acc) => acc.id === selected)}
      emptyState={
        <EmptyState className="h-full w-full flex items-center justify-center">
          <EmptyStateIcon>
            <CheckCircleIcon data-slot="icon" />
          </EmptyStateIcon>
          <EmptyStateHeading>No pending reports</EmptyStateHeading>
          <EmptyStateDescription>
            No accessions are pending report generation.
          </EmptyStateDescription>
        </EmptyState>
      }
      className="flex-1"
    >
      {(acc) => (
        <NavListItem asChild key={acc.id}>
          <ReportListItem
            accession={acc}
            key={acc.id}
            isQueued={queuedIds.includes(acc.id)}
            onGenerated={onGenerated}
          />
        </NavListItem>
      )}
    </NavList>
  );
}
